export const referralStatuses = [
  { value: "PENDING", label: "Pending" },
  { value: "SUCCESS", label: "Success" },
];

export enum ReferralStatusTypeEnum {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}
